export default "__VITE_ASSET__DoYdioRe__"